import classNames from 'classnames';
import React from 'react';

import Icon, { ICON_TYPES } from '@commons/Icon';

import { isWCAG21_2_Enabled } from '@services/featureFlags';

import styles from './validation.scss';

export function determineIconType(isError) {
  if (isError) return ICON_TYPES.CLOSE;
  return ICON_TYPES.ARROW_RIGHT;
}

interface ValidationMessageProps {
  ariaHidden?: boolean;
  caption?: string;
  containerStyles?: string;
  isError?: boolean;
  hasIcon?: boolean;
  shouldRender?: boolean;
  domId?: string;
}

export default function ValidationMessage({
  ariaHidden,
  caption,
  containerStyles,
  isError = false,
  hasIcon = true,
  shouldRender = true,
  domId
}: ValidationMessageProps) {
  if (!shouldRender) return null;

  const mainContainerStyles = classNames(
    styles.validationBlock,
    containerStyles,
    'validationMessage',
    {
      [styles.errorBlock]: isError,
      [styles.requiredBlock]: !isError,
      [styles.opacityPointEight]: isWCAG21_2_Enabled() && !isError
    }
  );

  const iconType = determineIconType(isError);

  return (
    <span id={domId} className={mainContainerStyles} aria-hidden={ariaHidden}>
      <Icon containerStyles={styles.validationIcon} type={iconType} shouldRender={hasIcon} />
      <span className={styles.caption} dangerouslySetInnerHTML={{ __html: caption }} />
    </span>
  );
}
